<template>
  <div
    class="popup-list login-content"
    v-show="popupActive == 'login'"
    style="height: 100px"
  >
    <div
      id="popup"
      class="popup popup-login-wrap"
      @click.stop="backgroundClickedCancel"
    >
      <div class="popup-inner">
        <div class="popup-head">
          <i class="icon-close" title="关闭" @click.stop="cancelPopup">
            <icon-base
              :icon-name="Icons.PopupClose.iconName"
              v-bind="Icons.PopupClose"
            >
              <icon-popup-close
                class="path-icon-close"
                :icon-name="Icons.PopupClose.iconName"
                v-bind="Icons.PopupClose"
              />
            </icon-base>
          </i>
        </div>
        <!-- 登录注册找回密码弹框 -->
        <div class="popup-content">
          <div class="popup-login">
            <div class="tab" >
              <span class="item active" v-if="isLogin">用户 登录</span>
              <span
                :class="['item', isPhone == true ? 'active' : '']"
                v-if="!isLogin && !isSafe && !isReset"
                @click="RegPhone"
                >手机注册</span
              >
              <span
                :class="['item', isPhone == false ? 'active' : '']"
                v-if="!isLogin && !isSafe && !isReset"
                @click="RegMail"
                >邮箱注册</span
              >
              <span class="item active" v-if="!isLogin && isSafe && !isReset"
                >账号安全</span
              >
              <span class="item active" v-if="!isLogin && !isSafe && isReset"
                >重置密码</span
              >
            </div>
            <!--登录  -->
            <el-form
              class="login"
              :model="loginForm"
              ref="loginForm"
              :rules="loginRules"
              status-icon
              @submit.native.prevent
               v-if="isLogin"
            >
              <el-form-item class="input-item" prop="account">
                <i class="ico01"></i>
                <el-input
                  type="text"
                  class="Acount"
                  autofocus="autofocus"
                  placeholder="账号"
                  v-model.trim="loginForm.loginName"
                  autocomplete="off"
                />
                <!-- <div class="tip"></div> -->
              </el-form-item>
              <el-form-item class="input-item mb60" prop="pass">
                <i class="ico02"></i>
                <el-input
                  type="password"
                  class="password"
                  placeholder="密码"
                  v-model.trim="loginForm.Password"
                  @keyup.enter.native="Login('loginForm')"
                />
              </el-form-item>
              <div>
                <el-button class="input-login" @click="Login('loginForm')"
                  >登录
                </el-button>
                <input
                  v-if="false"
                  class="input-login-reg"
                  value="注册"
                  readonly="readonly"
                  @click="RegSwitch"
                  native-type="submit"
                />
              </div>
              <div class="note">
                <el-checkbox v-model="LoginTeenDays" v-if="false"></el-checkbox>
                <span class="info" v-if="false">十天内免登录</span>
                <span class="forget" @click="SafeSwich" v-if="false"
                  >忘记密码</span
                >
              </div>
            </el-form>
            <!--手机注册-->
            <el-form
              class="phone"
              v-if="!isLogin && isPhone && !isSafe && !isReset"
              :model="signupForm"
              ref="signupForm"
              :rules="signupRules"
              status-icon
              @submit.native.prevent
            >
              <el-form-item class="input-item" prop="phone2">
                <i class="ico03"></i>
                <el-input
                  type="text"
                  class="input number-phone"
                  autofocus="autofocus"
                  autocomplete="off"
                  placeholder="输入手机号码"
                  v-model.trim="signupForm.loginName"
                />
                <em class="ico05"></em>
              </el-form-item>
              <el-form-item class="input-item" prop="pass2">
                <i class="ico02"></i>
                <el-input
                  type="password"
                  class="input password-phone"
                  placeholder="设置密码（6-20位字母、数字）"
                  autofocus="autofocus"
                  autocomplete="off"
                  v-model.trim="signupForm.Password"
                />
              </el-form-item>

              <el-form-item class="input-item" prop="code">
                <el-input
                  type="password"
                  class="input input-code"
                  placeholder="输入手机验证码"
                  v-model.trim="signupForm.code"
                />
                <span class="send-code" @click="sendVerifyCode('phone', '1')"
                  >{{ codeVal != 'sending' ? '发送验证码' : codeTimer
                  }}<em v-if="codeVal == 'sending'">s</em></span
                >
              </el-form-item>

              <div class="note">
                <el-checkbox v-model="phoneChecked"></el-checkbox>
                <span class="info">
                  我已阅读并同意
                  <em class="serve">《服务条款》</em>和
                  <em class="privacy">《隐私协议》</em>
                </span>
              </div>

              <div>
                <input
                  :class="['input-reg', !phoneChecked ? 'disabled' : '']"
                  value="注册"
                  readonly="readonly"
                  @click="confirmPhoneSignup('signupForm')"
                />
              </div>
            </el-form>
            <!--邮箱注册-->
            <el-form
              class="mail"
              v-if="!isLogin && !isPhone && !isSafe && !isReset"
              :model="signupEmailForm"
              ref="signupEmailForm"
              :rules="signupEmailRules"
              status-icon
              @submit.native.prevent
            >
              <el-form-item class="input-item" prop="email">
                <i class="ico04"></i>
                <el-input
                  type="text"
                  class="input number-phone"
                  placeholder="输入邮箱地址"
                  autofocus="autofocus"
                  autocomplete="off"
                  v-model.trim="signupEmailForm.loginName"
                />
                <div class="tip"></div>
                <em class="ico06"></em>
              </el-form-item>
              <el-form-item class="input-item" prop="pass3">
                <i class="ico02"></i>
                <el-input
                  type="password"
                  class="input password-phone"
                  placeholder="设置密码（6-20位字母、数字）"
                  autofocus="autofocus"
                  autocomplete="off"
                  v-model.trim="signupEmailForm.Password"
                />
              </el-form-item>

              <el-form-item class="input-item" prop="emaiCode">
                <el-input
                  type="password"
                  class="input input-code"
                  placeholder="输入邮箱验证码"
                  v-model.trim="signupEmailForm.code"
                />
                <span class="send-code" @click="sendVerifyCode('email', '1')"
                  >{{ codeVal != 'sending' ? '发送验证码' : codeTimer
                  }}<em v-if="codeVal == 'sending'">s</em></span
                >
              </el-form-item>

              <div class="note">
                <el-checkbox v-model="emailChecked"></el-checkbox>
                <span class="info">
                  我已阅读并同意
                  <em class="serve">《服务条款》</em>和
                  <em class="privacy">《隐私协议》</em>
                </span>
              </div>

              <div>
                <input
                  class="input-reg"
                  value="注册"
                  readonly="readonly"
                  :class="['input-reg', !emailChecked ? 'disabled' : '']"
                  @click="confirmEmileSignup('signupEmailForm')"
                />
              </div>
            </el-form>
            <!--账号安全-->
            <el-form
              class="safe"
              v-if="!isLogin && isSafe && !isReset"
              :model="safeForm"
              ref="safeForm"
              :rules="safeRules"
              status-icon
              @submit.native.prevent
            >
              <div class="input-item mb0">
                <p class="reminder">请输入您的账号信息</p>
              </div>

              <el-form-item class="input-item mb40" prop="safeAccount">
                <i class="ico03"></i>
                <el-input
                  class="input input-code w100"
                  placeholder="请输入手机号码/邮箱"
                  autofocus="autofocus"
                  autocomplete="off"
                  v-model.trim="safeForm.loginName"
                />
              </el-form-item>

              <el-form-item class="input-item" prop="safeCode">
                <el-input
                  class="input input-code"
                  placeholder="输入验证码"
                  v-model.trim="safeForm.code"
                />
                <span
                  v-if="isSafe"
                  :class="['send-code', !safeForm.loginName ? 'disabled' : '']"
                  @click="sendVerifyCode('', '2')"
                  >{{ codeVal != 'sending' ? '发送验证码' : codeTimer
                  }}<em v-if="codeVal == 'sending'">s</em></span
                >
              </el-form-item>

              <div>
                <input
                  :class="[
                    'input-reg',
                    'mt50',
                    !saveNextVal || codeVal == 'sended' ? 'disabled' : '',
                  ]"
                  readonly="readonly"
                  value="下一步"
                  @click="SafeNext('safeForm')"
                />
              </div>
            </el-form>
            <!--重置密码-->
            <el-form
              class="safe reset-form"
              v-if="!isLogin && !isSafe && isReset"
              :model="resetForm"
              ref="resetForm"
              :rules="resetRules"
              status-icon
              @submit.native.prevent
            >
              <el-form-item class="input-item" prop="newPass">
                <el-input
                  type="password"
                  class="input input-code w100"
                  placeholder="8-16位密码，区分大小写"
                  autofocus="autofocus"
                  autocomplete="off"
                  v-model.trim="resetForm.Password"
                  @input="varifyPassSet"
                />
              </el-form-item>

              <!-- <el-form-item class="input-item" prop="confirmPass">
                  <el-input
                    type="password"
                    class="input input-code w100"
                    placeholder="再次确认密码"
                    autofocus="autofocus"
                    autocomplete="off"
                    v-model.trim="resetForm.Password2"
                  />
                </el-form-item> -->
              <div class="pass-show-wrap">
                <span :class="[passStatus ? 'weak' : '']"></span>
                <span
                  :class="[
                    passStatus == 'medium' || passStatus == 'strong'
                      ? 'medium'
                      : '',
                  ]"
                ></span>
                <span :class="[passStatus == 'strong' ? 'strong' : '']"></span>
                <p>密码强度</p>
              </div>
              <div v-show="resetError" class="tip-wrap">
                <p>*长度为8-16个字符</p>
                <p>*不能使用空格、中文</p>
                <p>*不能含有非法字符</p>
              </div>
              <div>
                <input
                  class="input-reg mt50 confirm-reset"
                  value="重置"
                  readonly="readonly"
                  @click="Reset('resetForm')"
                />
              </div>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import GatPopup from '@/components/common/GatPopup'

import LOGIN from '@/axios/login/login'
import IconPopupClose from '@/components/icons/typography/PopupClose'

export default {
  name: 'Login',
  components: { IconPopupClose },
  props: {},
  data() {
    const pas_match = /^(?=.*[a-zA-Z])((?=.*[0-9])|(?=.*[._~!@#$^&*]))[A-Za-z0-9._~!@#$^&*]{8,20}$/, //验证密码
      match_pass = /^[\da-zA-Z._~!@#$^&*]{6,20}$/, //验证密码
      phone_match = /^1[358]\d{9}$/, //验证电话
      mail_match = /^[A-Za-z0-9](([_\.\-]?[a-zA-Z0-9]+)*)@([A-Za-z0-9]+)(([\.\-]?[a-zA-Z0-9]+)*)\.([A-Za-z]{2,})$/

    var validateAccount = (rule, value, callback) => {
      if (this.loginForm.loginName == '') {
        callback(new Error('请输入账号'))
      } else {
        callback()
      }
    }

    var validatePass = (rule, value, callback) => {
      if (this.loginForm.Password == '') {
        callback(new Error('请输入密码'))
      } else {
        if (!match_pass.test(this.loginForm.Password)) {
          callback(new Error('请输入6-20位密码'))
        }
        this.$refs.loginForm.validateField('checkPass')
        callback()
      }
    }

    //验证手机注册
    var validatePhone = (rule, value, callback) => {
      if (!this.signupForm.loginName || this.signupForm.loginName == '') {
        callback(new Error('请输入手机号'))
      } else if (!phone_match.test(this.signupForm.loginName)) {
        callback(new Error('手机号格式不正确'))
      } else {
        callback()
      }
    }

    var validatePass2 = (rule, value, callback) => {
      if (this.signupForm.Password == '') {
        callback(new Error('请输入密码'))
      } else {
        if (!match_pass.test(this.signupForm.Password)) {
          callback(new Error('请输入8-16位密码'))
        }
        this.$refs.signupForm.validateField('checkPass')
        callback()
      }
    }
    var validateCode = (rule, value, callback) => {
      if (this.signupForm.code == '') {
        callback(new Error('请输入验证码'))
      } else if (this.codeTimer == 0 && this.codeVal == 'sended') {
        callback(new Error('验证码失效，请重新发送'))
      } else if (this.code != this.signupForm.code) {
        callback(new Error('验证码错误'))
      } else {
        callback()
      }
    }

    //验证邮箱注册
    var validateEmail = (rule, value, callback) => {
      if (
        !this.signupEmailForm.loginName ||
        this.signupEmailForm.loginName == ''
      ) {
        callback(new Error('请输入正确的邮箱'))
      } else if (!mail_match.test(this.signupEmailForm.loginName)) {
        callback(new Error('邮箱格式不正确'))
      } else {
        callback()
      }
    }
    var validatePass3 = (rule, value, callback) => {
      if (this.signupEmailForm.Password == '') {
        callback(new Error('请输入密码'))
      } else {
        if (!match_pass.test(this.signupEmailForm.Password)) {
          callback(new Error('请输入8-16位密码'))
        }
        this.$refs.signupEmailForm.validateField('checkPass')
        callback()
      }
    }
    var validateEmaiCode = (rule, value, callback) => {
      if (this.signupEmailForm.code == '') {
        callback(new Error('请输入验证码'))
      } else if (this.codeTimer == 0 && this.codeVal == 'sended') {
        callback(new Error('验证码失效，请重新发送'))
      } else if (this.code != this.signupEmailForm.code) {
        callback(new Error('验证码错误'))
      } else {
        callback()
      }
    }
    //安全验证，验证手机和邮箱
    var validateSafe = (rule, value, callback) => {
      let account = this.safeForm.loginName
      if (!this.safeForm.loginName || this.safeForm.loginName == '') {
        callback(new Error('请输入正确的账户'))
      } else if (!phone_match.test(account) && !mail_match.test(account)) {
        callback(new Error('账户格式不正确'))
      } else {
        callback()
      }
    }
    var validateSafeCode = (rule, value, callback) => {
      if (this.safeForm.code == '') {
        callback(new Error('请输入验证码'))
        this.saveNextVal = false
      } else if (this.codeTimer == 0 && this.codeVal == 'sended') {
        callback(new Error('验证码失效，请重新发送'))
        this.saveNextVal = false
      } else if (this.code != this.safeForm.code) {
        callback(new Error('验证码错误'))
        this.saveNextVal = false
      } else {
        callback()
        this.saveNextVal = true
      }
    }

    //重置密码
    var validateNewPass = (rule, value, callback) => {
      let pass = this.resetForm.Password
      if (this.resetForm.Password == '') {
        callback(new Error(''))
        this.resetError = true
      } else {
        if (!match_pass.test(this.resetForm.Password)) {
          callback(new Error(''))
          this.resetError = true
          // callback(new Error("请输入8-20位密码"));
        }
        if (/[\s|\u4e00-\u9fa5].*/.test(pass)) {
          this.resetError = true
          callback(new Error(''))
          // callback(new Error("不能使用空格、中文"));
        } else if (pass.length < 8 || pass.length > 20) {
          callback(new Error(''))
          // callback(new Error("长度为8-20个字符"));
          this.resetError = true
        } else if (/[\s|\u4e00-\u9fa5].*/.test(pass)) {
          callback(new Error('不能使用空格、中文'))
          this.resetError = true
          // callback(new Error("不能使用空格、中文"));
        } else if (!this.passStatus) {
          callback(new Error(''))
          // callback(new Error("不能含有非法字符"));
          this.resetError = true
        } else {
          this.$refs.resetForm.validateField('checkPass')
          this.resetError = false
          callback()
        }
      }
    }

    return {
      isLogin: true,
      isPhone: true,
      isSafe: false,
      isReset: false,
      hasLogin: null,
      roleNames: null,
      userRole: 1,
      userType: '', //保存用户类型
      loginName: '',
      Password: '',
      loginForm: {
        loginName: '',
        Password: '',
      },
      signupForm: {
        loginName: '',
        Password: '',
        code: '',
      },
      signupEmailForm: {
        loginName: '',
        Password: '',
        code: '',
      },
      safeForm: {
        loginName: '',
        Password: '',
        code: '',
      },
      saveNextVal: false,
      resetForm: {
        Password: '',
        Password2: '',
      },
      LoginTeenDays: true,
      code: '', //验证码
      timer: null,
      codeTimer: 120, //时间计时器
      codeVal: '', //验证码状态
      popupActive: '',
      checked: true,
      phoneChecked: true,
      emailChecked: true,
      resetError: false,
      passStatus: null, //设置密码的验证状态
      accountInfo: {},
      Icons: {
        PopupClose: {
          iconName: '关闭',
          viewBox: '0 0 14 14',
          width: '14',
          height: '14',
          // iconColor: "#fff"
        },
      },
      //编辑器列表;
      loginRules: {
        //登录验证
        account: [{ validator: validateAccount, trigger: 'blur' }],
        pass: [{ validator: validatePass, trigger: 'blur' }],
      },
      //手机注册验证
      signupRules: {
        phone2: [{ validator: validatePhone, trigger: 'blur', equired: true }],
        pass2: [{ validator: validatePass2, trigger: 'blur', equired: true }],
        code: [{ validator: validateCode, trigger: 'blur', equired: true }],
      },
      //邮箱注册验证
      signupEmailRules: {
        email: [{ validator: validateEmail, trigger: 'blur', equired: true }],
        pass3: [{ validator: validatePass3, trigger: 'blur', equired: true }],
        emaiCode: [
          { validator: validateEmaiCode, trigger: 'blur', equired: true },
        ],
      },
      //账号安全验证
      safeRules: {
        safeAccount: [
          { validator: validateSafe, trigger: 'blur', equired: true },
        ],
        safeCode: [
          { validator: validateSafeCode, trigger: 'blur', equired: true },
        ],
      },
      //账号密码重置验证
      resetRules: {
        newPass: [
          { validator: validateNewPass, trigger: 'blur', equired: true },
        ],
      },
    }
  },
  watch: {},
  created() {},
  mounted() {},
  methods: {
    //登录弹窗
    activeLoginPopup() {
      this.popupActive = 'login'
      this.isLogin = true
      this.isPhone = false
      this.isSafe = false
      this.isReset = false
      this.loginForm = { loginName: '', Password: '' }
      this.signupForm = { loginName: '', Password: '', code: '' }
      this.signupEmailForm = { loginName: '', Password: '', code: '' }
      this.safeForm = { loginName: '', code: '' }
      this.resetForm = { Password: '' }
      this.codeTimer = 120
      this.codeVal = ''
      this.resetError = false
      this.saveNextVal = false
    },
    backgroundClickedCancel(evt) {
      // 点击背景关闭弹窗
      var target = evt.target
      if (target.classList.contains('popup')) {
        this.cancelPopup()
      }
    },
    // // 取消弹窗
    cancelPopup() {
      this.popupActive = ''
      this.isLogin = false
      this.isPhone = false
      this.isSafe = false
      this.isReset = false
      this.$emit('cancelLogin')
      try {
        this.$refs.loginForm.clearValidate()
      } catch (e) {
        console.log(e)
      }
    },
    Login(formName) {
      var self = this,
        loginForm = this.loginForm
      loginForm.loginName = loginForm.loginName.trim()
      let data = {
        loginName: loginForm.loginName,
        pwd: loginForm.Password,
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          LOGIN.login(data).then((res) => {
            if (res && res.isSuccess) {
              let Data = res.data
              self.hasLogin = true
              sessionStorage.setItem('hasLogin', true)
              sessionStorage.setItem('accountInfo', JSON.stringify(Data.data))
              sessionStorage.setItem('token', JSON.stringify(Data.token))
              this.$store.commit('accountInfo', Data.data)
              self.$store.commit('token', Data.token)
              self.$store.commit('userType', Data.data.type) // 用户类型
              self.token = Data.token
              self.userType = Data.data.type
              self.accountInfo = Data.data
              self.$store.commit('userStatus', true)
              try {
                self.$parent.loginStatusHandler(Data)
              } catch (e) {}

              self.popupActive = ''
              self.$refs.loginForm.clearValidate()

              if (self.LoginTeenDays) {
                if (!localStorage.tokenTime) {
                  let date = new Date().getTime() + 6 * 3600 * 1000
                  localStorage.setItem('tokenTime', date)
                  // localStorage.loginForm =JSON.stringify(loginForm)
                } else {
                  localStorage.clear()
                }
                self.$emit('confirmLogin')
              }
            } else {
              //报错的提示
              this.$message.error(res.returnMsg)
            }
          })
        }
      })
    },
    //自动登录
    // autoLogin() {
    // var self = this,
    //     loginForm = localStorage.loginForm,
    //     data = {
    //       ...loginForm
    //     };
    // Login.LoginPost(data).then(res => {
    //   var success = res.isSuccess;
    //   if (success) {
    //     let Data = res.Data;
    //     self.hasLogin = true;
    //     sessionStorage.setItem("hasLogin", true);
    //     sessionStorage.setItem("accountInfo", JSON.stringify(Data));
    //     self.accountInfo = Data;
    //     this.$store.commit("accountInfo", Data);
    //     self.$store.commit("token", Data.token);
    //     self.$store.commit("userType", Data.UserType);
    //     self.token = Data.token;
    //     self.hasLogin = true;
    //     self.userType = Data.UserType;
    //     self.$store.commit("userStatus", true);
    //     self.popupActive = "";
    //     self.User.profile = JSON.parse(
    //         sessionStorage.getItem("accountInfo")
    //     ).UserImgUrl;
    //     self.$forceUpdate();
    //     if (self.LoginTeenDays) {
    //       if (!localStorage.tokenTime) {
    //         let date = new Date().getTime() + 6 * 3600 * 1000;
    //         localStorage.setItem("tokenTime", date);
    //         localStorage.loginForm = loginForm;
    //       } else {
    //         localStorage.clear();
    //       }
    //       self.$emit("confirmLogin");
    //     }
    //   }
    // });
    // },
    //忘记密码跳转
    SafeSwich() {
      try {
        this.$refs.loginForm.clearValidate()
      } catch (e) {
        console.log(e)
      }
      this.isLogin = false
      this.isSafe = true
      this.isReset = false
    },
    //退出登录
    quitLogin() {
      let that = this;
      function clearState () {
        that.roleNames = '';
        that.hasLogin = false;
        that.accountInfo.realName = '';
        that.accountInfo.roleNames = '';
        that.token = '';
        //清除缓存
        localStorage.clear();
        sessionStorage.clear();
        //GatHead.vue组件设置状态
        that.$parent.loginStatusHandler(false);

        that.$store.commit('userStatus', 'false');
        that.$store.commit('quitLogin');
        that.$router.push('/');
      }

      // 退出调注销用户接口
      LOGIN.loginOut().then((res) => {
        clearState();
      }).catch((err) => {
        clearState();
      });
    },

    //跳转到注册页
    RegSwitch() {
      try {
        this.$refs.loginForm.clearValidate()
      } catch (e) {
        console.log(e)
      }
      try {
        this.$refs.signupEmailForm.clearValidate()
      } catch (e) {
        console.log(e)
      }
      this.isLogin = false
      this.isReset = false
      this.isSafe = false
      this.isPhone = true
    },

    //发送验证码
    /**
     @param accountType 注册账号(手机号或邮箱)
     @param type 1 注册时;2 重置时
     **/
    async sendVerifyCode(accountType, type) {
      // if (this.codeVal == "sending" || this.codeVal == "loading") return;
      // this.accountVal = false; //清空该账号状态
      // this.code = ""; //清空验证码
      // let account,
      //     phone_match = /^1[358]\d{9}$/, //验证电话
      //     mail_match = /^[A-Za-z0-9](([_\.\-]?[a-zA-Z0-9]+)*)@([A-Za-z0-9]+)(([\.\-]?[a-zA-Z0-9]+)*)\.([A-Za-z]{2,})$/;
      // //注册验证
      // if (type == "1") {
      //   if (accountType == "phone") {
      //     account = this.signupForm.loginName;
      //     this.signupForm.code = "";
      //   } else if (accountType == "email") {
      //     account = this.signupEmailForm.loginName;
      //     this.signupEmailForm.code = "";
      //   }
      // } else if (type == "2") {
      //   //找回密码验证
      //   let safeForm = this.safeForm;
      //   account = safeForm.loginName;
      //   if (!phone_match.test(account) && !mail_match.test(account)) {
      //     return;
      //   }
      // }
      // if (!account) return;
      // //必须等60s后才能进行点击调用验证码请求，防止短时间多次点击。
      // this.codeVal = "loading";
      // let res = await Login.SendVerificationCode(account, type);
      // if (res && res.isSuccess == true) {
      //   this.codeVal = "sending";
      //   this.codeVerify(res.Data); //获取验证码并计时
      //   this.$message.success("发送成功");
      // } else if (res.ErrorCode && res.ErrorCode == "50109") {
      //   this.$message.error(res.ErrorMsg);
      //   this.codeVal = "sended";
      //   this.accountVal = true; //表示这个账号已经注册，不允许再注册
      // }
    },
    //获取验证码并计时
    codeVerify(code) {
      this.code = code
      this.timer = setInterval(() => {
        if (this.codeTimer > 0) {
          this.codeTimer--
        } else {
          clearInterval(this.timer)
          this.codeTimer = 120
          this.codeVal = 'sended'
        }
      }, 1000)
    },
    //切换手机注册表单
    RegPhone() {
      try {
        this.$refs.loginForm.clearValidate()
      } catch (e) {
        console.log(e)
      }
      this.isLogin = false
      this.isPhone = true
      this.isSafe = false
      this.isReset = false
    },
    //确定手机注册
    async confirmPhoneSignup(formName) {
      // this.$refs[formName].validate(async valid => {
      //   if (valid) {
      //     let signupForm = this.signupForm,
      //         { loginName, Password, code } = signupForm,
      //         data = {};
      //     if (this.accountVal) {
      //       return this.$message.error("该账号已被注册");
      //     }
      //     if (this.codeVal == "sended") {
      //       return this.$message.error("请再次发送验证码");
      //     }
      //     if (!this.code) {
      //       return this.$message.error("请输入验证码");
      //     }
      //     if (!loginName || !Password || !code) {
      //       return;
      //     }
      //     data = {
      //       loginName: loginName,
      //       Password: Password
      //     };
      //     let regResult = await Login.Register(data);
      //     if (regResult && regResult.isSuccess) {
      //       this.$message.success("注册成功");
      //       this.codeVal = "sended";
      //     } else if (regResult.ErrorMsg) {
      //       this.$message.error(regResult.ErrorMsg);
      //     }
      //   }
      // });
    },
    //切换邮箱注册表单
    RegMail() {
      try {
        this.$refs.signupForm.clearValidate()
      } catch (e) {
        console.log(e)
      }
      this.isPhone = false
      this.isSafe = false
      this.isReset = false
    },
    //确定用邮箱注册
    async confirmEmileSignup(formName) {
      // this.$refs[formName].validate(async valid => {
      //   if (valid) {
      //     let signupEmailForm = this.signupEmailForm,
      //         { loginName, Password, code } = signupEmailForm,
      //         data = {};
      //     if (this.accountVal) {
      //       return this.$message.error("该账号已被注册");
      //     }
      //     if (this.codeVal == "sended") {
      //       return this.$message.error("请再次发送验证码");
      //     }
      //     if (!this.code) {
      //       return this.$message.error("请输入验证码");
      //     }
      //     if (!loginName || !Password || !code) {
      //       return;
      //     }
      //     data = {
      //       loginName: loginName,
      //       Password: Password
      //     };
      //     let regResult = await Login.Register(data);
      //     if (regResult && regResult.isSuccess) {
      //       this.$message.success("注册成功");
      //       this.codeVal = "sended";
      //     } else if (regResult.ErrorMsg) {
      //       this.$message.error(regResult.ErrorMsg);
      //     }
      //   }
      // });
    },

    SafeNext(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          try {
            this.$refs.safeForm.clearValidate()
          } catch (e) {
            console.log(e)
          }
          this.isLogin = false
          this.isSafe = false
          this.isReset = true
          this.codeVal = 120
          clearInterval(this.timer)
        }
      })
    },
    //验证密码强度
    varifyPassSet(val) {
      let pass = this.resetForm.Password.trim(),
        len = pass.length,
        reg_pass_1 = /^[\da-zA-Z._~!@#$^&*]{8,20}$/, //含有字母、数字、字符中的1种
        reg_pass_2 = /^(?![\d]+$)(?![a-zA-Z]+$)(?![!#$%^&*]+$)[\da-zA-Z._~!@#$^&*]{8,20}$/, //含有字母、数字、特殊字符中的2种以上的
        reg_pass_3 = /^(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[._~!@#$^&*])[0-9a-zA-Z._~!@#$^&*]{8,20}$/ //含有字母、数字、特殊字符中的3种
      // debugger;
      if (!reg_pass_1.test(pass)) {
        this.passStatus = null
      } else if (reg_pass_1.test(pass) && !reg_pass_2.test(pass)) {
        this.passStatus = 'weak'
      } else if (reg_pass_2.test(pass) && !reg_pass_3.test(pass)) {
        this.passStatus = 'medium'
      } else if (reg_pass_3.test(pass)) {
        this.passStatus = 'strong'
      }
      // if()
    },

    //重置
    Reset(formName) {
      // this.$refs[formName].validate(async valid => {
      //   if (valid) {
      //     let resetForm = this.resetForm,
      //         loginName = this.safeForm.loginName,
      //         { Password, code } = resetForm,
      //         data = { loginName, Password };
      //     let res = await Login.ResetPassword(data);
      //     if (res && res.isSuccess) {
      //       this.$message.success(res.Data);
      //       this.isReset = false;
      //       this.popupActive = "";
      //       try {
      //         this.$refs[formName].resetFields();
      //         this.$refs[formName].clearValidate();
      //       } catch (e) { console.log(e)
      //       }
      //     } else if (res.ErrorMsg) {
      //       this.$message.error(res.ErrorMsg);
      //     }
      //   }
      // });
    },
  },
}
</script>

<style lang="scss" scoped>
@import './Login.scss';
</style>
